module.exports = __webpack_public_path__ + "img/glamping_4.2025d28d.jpg";